import {Component} from '@angular/core';

@Component({
    templateUrl: './PledgeDemographicComponent.html',
    standalone: false
})
export class PledgeDemographicComponent {
}
